<template>
  <form @submit.prevent>
    <div>
      <h2 v-if="selectedEntity">
        <span>{{ selectedEntity.name | translate }}</span>
      </h2>

      <br />

      <div class="w-100 border border-dark bg-light-success">
        <h5 class="mt-1 ml-1 m-2">
          <strong>
            {{ $t("file-manager.latest-version") }}
          </strong>
        </h5>
      </div>
      <div v-if="isPeriodical" class="float-right mt-4 mb-4">
        <span class="hand text-right float-right text-primary">
          <i class="bx bxs-navigation font-size-16 align-middle mr-1"></i>
          <h5 class="mr-1 d-inline text-primary" @click="redirectToApprovalSurvey(selectedEntity)">{{ $t("file-approval-survey.plural") }}</h5>
        </span>
      </div>
      <div class="table-responsive mt-4" style="min-height: 140px;">
        <table class="table align-middle table-striped  mb-0">
          <thead class="table-dark">
            <tr>
              <th>{{ $t("file-manager.name") }}</th>
              <th>{{ $t("file-manager.no") }}</th>
              <th>{{ $t("file-manager.version-no") }}</th>
              <th>{{ $t("file-manager.version-start-date") }}</th>
              <th>{{ $t("file-manager.admin") }}</th>
              <th>{{ $t("file-manager.uploader") }}</th>
              <th>{{ $t("file-manager.file") }}</th>
              <th>{{ $t("policy.is-periodical") }}</th>
              <!-- <th>{{ $t("file-manager.approved-accounts") }}</th> -->
              <!-- <th>{{ $t("file-approval-survey.plural") }}</th> -->
            </tr>
          </thead>
          <tbody v-if="selectedEntity">
            <tr>
              <td>
                <a href="javascript: void(0);" class="text-dark fw-medium"
                  ><i class="mdi mdi-file-document font-size-16 align-middle text-primary me-2"></i> {{ selectedEntity.name | translate }}</a
                >
              </td>
              <td>{{ selectedEntity.no }}</td>
              <td>{{ selectedEntity.version }}</td>
              <td>{{ selectedEntity.versionStartDate | date }}</td>
              <td>
                <span v-if="selectedEntity.admin">{{ selectedEntity.admin.name }}</span>
              </td>
              <td>
                <span v-if="selectedEntity.uploader">{{ selectedEntity.uploader.name }}</span>
              </td>
              <td>
                <span v-if="selectedEntity" @click="downloadFile(selectedEntity)" v-b-tooltip.hover :title="$t('common.download')" class="hand">
                  <i class="bx bx-download font-size-16 align-middle mr-1"></i>
                  {{ selectedEntity.name | translate }}
                </span>
                <span v-else>
                  <i>({{ $t("file-manager.not-found") }})</i>
                </span>
              </td>
              <td class="text-center">{{ selectedEntity.isPeriodical ? $t("common.yes") : $t("common.no") }}</td>
              <!-- <td>{{ displayAccounts(selectedEntity.approval) }}</td> -->
              <!-- <td>
                <span class="hand">
                  <i class="bx bxs-navigation font-size-16 align-middle mr-1"></i>
                  <span @click="redirectToApprovalSurvey(selectedEntity)">{{ $t("file-approval-survey.plural") }}</span>
                </span>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w-100 border border-dark bg-light-warning">
        <h5 class="mt-1 ml-1">
          <strong>
            {{ $t("common.history") }}
          </strong>
        </h5>
      </div>

      <div class="table-responsive mt-4" style="min-height: 140px;">
        <table class="table align-middle  mb-0">
          <thead class="table-dark">
            <tr>
              <th>{{ $t("file-manager.name") }}</th>
              <th>{{ $t("file-manager.no") }}</th>
              <th>{{ $t("file-manager.version-no") }}</th>
              <th>{{ $t("file-manager.version-start-date") }}</th>
              <th>{{ $t("file-manager.version-end-date") }}</th>
              <th>{{ $t("file-manager.admin") }}</th>
              <th>{{ $t("file-manager.uploader") }}</th>
              <th>{{ $t("file-manager.file") }}</th>
              <th>{{ $t("policy.is-periodical") }}</th>
              <!-- <th>{{ $t("file-manager.approved-accounts") }}</th> -->
            </tr>
          </thead>
          <tbody v-if="selectedEntity && selectedEntity.history">
            <tr v-for="(historyItem, index) in selectedEntity.history" :key="historyItem._id + index" :class="{ highlight: historyItem._id === historyId }">
              <td>
                <a href="javascript: void(0);" class="text-dark fw-medium"
                  ><i class="mdi mdi-file-document font-size-16 align-middle text-primary me-2"></i> {{ historyItem.name | translate }}</a
                >
              </td>
              <td>{{ historyItem.no }}</td>
              <td>{{ historyItem.version }}</td>
              <td>{{ historyItem.versionStartDate | date }}</td>
              <td>{{ historyItem.versionEndDate | date }}</td>
              <!-- <td>{{ displayAccounts(historyItem.approval) }}</td> -->
              <td>
                <span v-if="historyItem.admin">{{ historyItem.admin.name }}</span>
              </td>
              <td>
                <span v-if="historyItem.uploader">{{ historyItem.uploader.name }}</span>
              </td>
              <td>
                <span v-if="historyItem" @click="downloadHistory(historyItem)" v-b-tooltip.hover :title="$t('common.download')" class="hand">
                  <i class="bx bx-download font-size-16 align-middle mr-1"></i>
                  {{ historyItem.name | translate }}
                </span>
                <span v-else>
                  <i>({{ $t("file-manager.not-found") }})</i>
                </span>
              </td>
              <td class="text-center">{{ historyItem.isPeriodical ? $t("common.yes") : $t("common.no") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const state = "fileManager";

export default {
  props: ["scope", "historyId"],
  data() {
    return {
      form: { parent: undefined, name: undefined },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
    },
  },

  computed: {
    isPeriodical() {
      return this.selectedEntity?.isPeriodical || this.selectedEntity?.history?.some((i) => i.isPeriodical);
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    selectedEntity() {
      return this.$store.getters[`${state}/selectedEntity`];
    },
  },
  async mounted() {},
  methods: {
    redirectToApprovalSurvey(file) {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/${file._id}/survey`);
    },
    displayAccounts(approval) {
      if (approval) {
        return approval.accounts.map((i) => i.account.name + " (" + this.$options.filters.date(i.approvedDate, true) + ")").join(", ");
      } else {
        return "";
      }
    },
    downloadFile(file) {
      this.$store.commit("fileManager/addDownloadedFile", { file });
    },
    downloadHistory(file) {
      this.$store.commit("fileManager/addDownloadedFile", { file, isHistory: true });
    },
  },
};
</script>
<style scoped>
.bg-light-warning {
  background-color: #ffbd8a;
}
.bg-light-success {
  background-color: #defcdf;
}
.redirect-approval-survey:hover {
  color: blue;
}

@keyframes blink {
  0% {
    background-color: rgba(200, 200, 200, 0.1); /* Soft gri arka plan */
  }
  50% {
    background-color: rgba(169, 169, 169, 0.2); /* Daha belirgin gri arka plan */
  }
  100% {
    background-color: rgba(200, 200, 200, 0.1); /* Soft gri arka plan */
  }
}

.highlight {
  animation: blink 1s ease-in-out 3;
  transition: background-color 0.2s;
}
</style>
